// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".poster-link{all:unset;width:100%;display:block;cursor:pointer}", ""]);
// Exports
module.exports = exports;
